module.exports = __webpack_public_path__ + "static/media/Iconfield02.8931f869.svg";